import { loadScript } from '../dom/script';

const mapboxLibraryLink: string = 'https://api.mapbox.com/mapbox-gl-js/v1.13.2/mapbox-gl.js';

export function loadMapboxGL(): Promise<void> {
    return loadScript( mapboxLibraryLink );
}
